import { Injectable } from '@angular/core';
import { ClosingRejected } from '@nodeModules/@itero/itero-client-communication';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { BaseShellEvent } from './base-shell-event';

@Injectable({ providedIn: 'root' })
export class ClosingRejectedEvent extends BaseShellEvent<ClosingRejected> {
	get eventName(): string {
		return ShellCommunicationEvents.ClosingRejected;
	}
}
